<template>
  <div id="home-page">
    <section class="carousel-section">
      <HomeCarousel v-if="carousel.length" :carousel="carousel"/>
    </section>
    <HomeFeaturedSerie/>
    <section class="featured-section">
      <IntersectionObserver
          v-if="isCarouselLoaded"
          :init-observer="true"
          :disconnect-observer="disconnetFeatured"
          :threshold="0.5"
          @intersect="HomeFeaturedIntersection"
      >
        <div v-if="!loadHomeFeatured" class="loader-container">
          <Loading color="black"/>
        </div>
        <HomeFeatured v-else/>
      </IntersectionObserver>
    </section>
    <section class="residents-section">
      <IntersectionObserver
          v-if="isCarouselLoaded"
          :init-observer="true"
          :disconnect-observer="disconnetResidents"
          :threshold="0.5"
          @intersect="HomeResidentsIntersection"
      >
        <div v-if="!loadHomeResidents" class="loader-container">
          <Loading color="black"/>
        </div>
        <HomeResidents v-else/>
      </IntersectionObserver>
    </section>
    <HomePromoBanner/>
    <section class="podcasts-section">
      <IntersectionObserver
          v-if="isCarouselLoaded"
          :init-observer="true"
          :disconnect-observer="disconnetPodcasts"
          :threshold="0.5"
          @intersect="HomePodcastsIntersection"
      >
        <div v-if="!loadHomePodcasts" class="loader-container">
          <Loading color="black"/>
        </div>
        <HomePodcasts v-else/>
      </IntersectionObserver>
    </section>
    <section class="trending-section">
      <IntersectionObserver
          v-if="isCarouselLoaded"
          :init-observer="true"
          :disconnect-observer="disconnetTrending"
          :threshold="0.5"
          @intersect="HomeTrendingIntersection"
      >
        <div v-if="!loadHomeTredning" class="loader-container">
          <Loading color="black"/>
        </div>
        <HomeTrending v-else/>
      </IntersectionObserver>
    </section>
  </div>
</template>
<script>
import axios from 'axios';
import IntersectionObserver from '@/components/ui/IntersectionObserver.vue';
import Loading from '@/components/ui/Loading.vue';
import HomeCarousel from '@/components/sections/HomeCarousel.vue';
import HomeFeatured from '@/components/sections/HomeFeatured.vue';
import HomeResidents from '@/components/sections/HomeResidents.vue';
import HomePodcasts from '@/components/sections/HomePodcasts.vue';
import HomeTrending from '@/components/sections/HomeTrending.vue';
import HomeFeaturedSerie from "@/components/sections/HomeFeaturedSerie.vue";
import HomePromoBanner from "@/components/sections/HomePromoBanner.vue";

import stegiRadioApp from '@/assets/images/stegi-radio-app.jpg'

export default {
  name: 'HomePage',
  components: {
    HomePromoBanner,
    HomeFeaturedSerie,
    IntersectionObserver,
    HomeCarousel,
    HomeFeatured,
    HomeResidents,
    HomePodcasts,
    HomeTrending,
    Loading
  },
  data: () => ({
    stegiRadioApp: stegiRadioApp,
    carousel: [],
    isCarouselLoaded: false,
    loadHomeFeatured: false,
    loadHomeResidents: false,
    loadHomePodcasts: false,
    loadHomeTredning: false,
    disconnetFeatured: false,
    disconnetResidents: false,
    disconnetPodcasts: false,
    disconnetTrending: false
  }),
  async mounted() {
    await this.getCarousel();
    this.isCarouselLoaded = true;
  },
  methods: {
    HomeFeaturedIntersection() {
      this.loadHomeFeatured = true;
      this.disconnetFeatured = true;
    },
    HomeResidentsIntersection() {
      this.loadHomeResidents = true;
      this.disconnetResidents = true;
    },
    HomePodcastsIntersection() {
      this.loadHomePodcasts = true;
      this.disconnetPodcasts = true;
    },
    HomeTrendingIntersection() {
      this.loadHomeTredning = true;
      this.disconnetTrending = true;
    },
    async getCarousel() {
      axios
          .get(this.$router.options.api + '/front/front-page-carousel')
          .then((response) => {
            this.carousel = response.data;
            this.carousel.unshift({
              mediaUrl: stegiRadioApp,
              title: "Our new app is here",
              date: null,
              location: null,
              description: "Available on iOS and Android. Download the app and stay connected wherever you go.",
              mainArtist: null,
              promo: "Scan QR code to download"
            })
          })
          .catch(error => console.error(error));
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}

div#home-page {
  margin-top: var(--headerHeight);
  @include media-breakpoint-down(lg) {
    margin-top: var(--headerHeight);
  }
}

section.carousel-section {
  height: calc(100vh - var(--headerHeight));
  @include media-breakpoint-down(lg) {
    height: calc(100vh - var(--headerHeight));
  }
}

section.featured-section {
  background-color: $c_bg_featured;
  position: relative;
}

section.residents-section {
  background-color: $c_bg_residents;
  padding-bottom: 50px;
  position: relative;
}

section.podcasts-section {
  background-color: $c_bg_podcasts;
  position: relative;
}

section.trending-section {
  background-color: $c_bg_trending;
  position: relative;
}

div#home-featured,
div#home-residents,
div#home-podcasts,
div#home-trending, .featured-serie, .home-promo-banner {
  padding-top: 30px;
  padding-bottom: 50px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  padding: 20px;
  @include media-breakpoint-up(xl) {
    max-width: 1060px;
  }
  @include media-breakpoint-up(xxl) {
    max-width: 1200px;
  }
}
</style>
